<template>
  <form
    name="trompetty-stand"
    class="mt-3 mx-auto col-12"
    @submit.prevent="sendPDF()"
    novalidate
  >
    <div class="d-flex flex-column mb-2">
      <fieldset>
        <label id="want-floor">Ik wil de vloer*</label>
        <div class="row ms-1">
          <div class="form-check d-flex flex-row col-12 col-md-1 me-1">
            <input
              class="form-check-input form-control me-1"
              type="radio"
              name="radio-delivery"
              id="radio-delivery-1"
              value="levering"
              v-model="offerte.leveringsManier"
              required
            />
            <label id="deliver" class="form-check-label" for="radio-delivery-1">
              Geleverd
            </label>
          </div>
          <div class="form-check d-flex flex-row col-12 col-md-1 me-1">
            <input
              class="form-check-input form-control me-1"
              type="radio"
              name="radio-delivery"
              id="radio-delivery-2"
              value="montage"
              v-model="offerte.leveringsManier"
            />
            <label id="assem" class="form-check-label" for="radio-delivery-2">
              Montage
            </label>
          </div>
          <div class="form-check d-flex flex-row col-12 col-md-3 me-1">
            <input
              class="form-check-input form-control me-1"
              type="radio"
              name="radio-delivery"
              id="radio-delivery-3"
              value="montage en demontage"
              v-model="offerte.leveringsManier"
            />
            <label
              id="assem-disas"
              class="form-check-label"
              for="radio-delivery-3"
            >
              Montage en demontage
            </label>
          </div>
        </div>
      </fieldset>
    </div>

    <div
      class="form-group col-12 mb-2"
      v-if="offerte.leveringsManier === 'levering'"
    >
      <div class="col-12 col-md-4">
        <label id="del-date" for="leveringDatum" class="form-label"
          >Datum levering</label
        ><input
          type="date"
          name="leveringDatum"
          class="form-control bg-light"
          v-model="offerte.datum.levering"
          required
          @blur="valid"
        />
      </div>
    </div>
    <div
      class="form-group row"
      v-if="
        offerte.leveringsManier === 'montage en demontage' ||
        offerte.leveringsManier === 'montage'
      "
    >
      <div class="col-12 col-md-4">
        <label id="assem-date" for="montageDatum" class="form-label"
          >Datum montage</label
        ><input
          type="date"
          name="montageDatum"
          id="montageDatum"
          class="form-control bg-light"
          v-model="offerte.datum.montage"
          required
          @blur="valid"
        />
      </div>
      <div class="col-md-1"></div>
      <div
        class="col-12 col-md-4"
        v-if="offerte.leveringsManier === 'montage en demontage'"
      >
        <label id="disas-date" for="demontageDatum" class="form-label"
          >Datum demontage</label
        ><input
          type="date"
          name="demontageDatum"
          class="form-control bg-light"
          v-model="offerte.datum.demontage"
          required
          @blur="valid"
        />
      </div>
    </div>

    <div class="form-group g-3 col-12 mb-1">
      <label
        for="individueleStandProjectNaam"
        class="form-label"
        id="project-name"
        >Naam project*</label
      >
      <input
        required
        type="text"
        name="individueleStandProjectNaam"
        class="form-control bg-light"
        v-model="offerte.projectNaam"
        @blur="valid"
      />
    </div>
    <div class="form-group g-3 col-12 mb-1">
      <label
        for="individueleStandProjectLand"
        class="form-label"
        id="project-coun"
        >Land project*</label
      >
      <input
        required
        type="text"
        name="individueleStandProjectLand"
        class="form-control bg-light"
        v-model="offerte.projectLand"
        @blur="valid"
      />
    </div>
    <div class="form-group g-3 col-12 mb-1">
      <label
        for="individueleStandProjectLocatie"
        class="form-label"
        id="loc-name"
        >Locatienaam*</label
      >
      <input
        required
        type="text"
        class="form-control bg-light"
        v-model="offerte.projectLocatie"
        @blur="valid"
      />
    </div>

    <div
      v-if="event === 'Individuele stand'"
      class="row justify-content-between"
    >
      <div class="form-group col-4">
        <label
          for="individueleStandProjectHalNaam"
          class="form-label"
          id="name-hall"
          >Halnaam*</label
        >
        <input
          required
          type="text"
          name="individueleStandProjectHalNaam"
          class="form-control bg-light"
          v-model="offerte.locatie.halNaam"
          @blur="valid"
        />
      </div>
      <div class="form-group col-3">
        <label
          for="individueleStandProjectHalNummer"
          class="form-label"
          id="nr-hall"
          >Halnummer*</label
        >
        <input
          required
          type="text"
          name="individueleStandProjectHalNummer"
          class="form-control bg-light"
          v-model="offerte.locatie.halNummer"
          @blur="valid"
        />
      </div>
      <div class="form-group col-3">
        <label
          for="individueleStandProjectStandNummer"
          class="form-label"
          id="nr-city"
          >Standnummer*</label
        >
        <input
          required
          type="text"
          name="individueleStandProjectStandNummer"
          class="form-control bg-light"
          v-model="offerte.locatie.standNummer"
          @blur="valid"
        />
      </div>
    </div>

    <div v-if="event === 'Individuele stand'" class="form-group col-12">
      <label for="individueleStandProjectSoortStand" class="form-label type-st"
        >Stand soort*</label
      >
      <div class="border-select" id="individueleStandProjectSoortStand_div" >
        <select
          required
          name="individueleStandProjectSoortStand"
          id="individueleStandProjectSoortStand"
          class="form-select bg-light"
          v-model="offerte.locatie.standSoort"
          @blur="valid"
        >
          <option class="type-st" value="" selected disabled>Stand soort</option>
          <option id="is-st" value="Eilandstand">Eilandstand</option>
          <option id="head-st" value="Kopstand">Kopstand</option>
          <option id="angle-pos" value="Hoekstand">Hoekstand</option>
          <option id="row-st" value="Rijenstand">Rijenstand</option>
        </select>
      </div>
    </div>

    <div v-if="event === 'Individuele stand'" class="form-group col-12">
      <label
        id="include"
        for="individueleStandProjectStroomWater"
        class="form-label"
        >Inclusief stroom en waterpunten*</label
      >
      <input
        required
        type="text"
        name="individueleStandProjectStroomWater"
        id="individueleStandProjectStroomWater"
        class="form-control bg-light"
        v-model="offerte.locatie.stroomWaterPunt"
        @blur="valid"
      />
    </div>
    <div v-if="event === 'Individuele stand'" class="form-group">
      <label
        id="mea-st"
        for="individueleStandProjectAfmetingStandLengte"
        class="form-label"
        >Afmeting stand*</label
      >
      <div class="row">
        <div class="col-4 me-3">
          <input
            required
            type="number"
            name="individueleStandProjectAfmetingStandLengte"
            id="individueleStandProjectAfmetingStandLengte"
            class="form-control bg-light"
            placeholder="lengte"
            v-model="offerte.locatie.standLengte"
            @blur="valid"
          />
        </div>
        <div class="col-4 me-3">
          <input
            required
            type="number"
            name="individueleStandProjectAfmetingStandBreedte"
            id="individueleStandProjectAfmetingStandBreedte"
            class="form-control bg-light"
            placeholder="Breedte"
            v-model="offerte.locatie.standBreedte"
            @blur="valid"
          />
        </div>
        <div
          class="col-3"
          v-show="
            offerte.locatie.standLengte * offerte.locatie.standBreedte > 0
          "
        >
          <p class="m-0 p-0" id="vierkantemeter">
            {{ offerte.locatie.standLengte * offerte.locatie.standBreedte }} m²
          </p>
        </div>
      </div>
    </div>

    <div v-if="event === 'Individuele stand'" class="form-group col-12">
      <label
        id="raised-fl"
        for="individueleStandProjectVerhoogdeVloer"
        class="form-label"
        >Verhoogde vloer*</label
      >
      <div class="border-select" id="individueleStandProjectVerhoogdeVloer_div" >
        <select
          required
          name="individueleStandProjectVerhoogdeVloer"
          id="individueleStandProjectVerhoogdeVloer"
          class="form-select bg-light"
          v-model="offerte.locatie.verhoogdeVloer"
          @blur="valid"
        >
          <option id="any-raised" value="" selected disabled>
            Verhoogde vloer aanwezig?
          </option>
          <option class="yes" value="Ja">Ja</option>
          <option class="no" value="Nee">Nee</option>
        </select>
      </div>
      <div v-if="offerte.locatie.verhoogdeVloer === 'Ja'">
        <label
          id="date-del"
          for="individueleStandProjectVerhoogdeVloerDatum"
          class="form-label"
          >Datum oplevering verhoogde vloer</label
        ><input
          type="date"
          name="individueleStandProjectVerhoogdeVloerDatum"
          id="individueleStandProjectVerhoogdeVloerDatum"
          class="form-control bg-light"
          v-model="offerte.locatie.opleveringDatum"
        /><label
          id="time-del"
          for="individueleStandProjectVerhoogdeVloertijd"
          class="form-label"
          >Tijdstip oplevering verhoogde vloer</label
        ><input
          type="time"
          name="individueleStandProjectVerhoogdeVloertijd"
          id="individueleStandProjectVerhoogdeVloertijd"
          class="form-control bg-light"
          v-model="offerte.locatie.opleveringTijd"
        />
      </div>
      <div class="form-group col-12">
        <label
          for="individueleStandProjectRandafwerking"
          class="form-label finish"
          >Randafwerking?*</label
        >
        <div class="border-select" id="individueleStandProjectRandafwerking_div" >
          <select
            required
            name="individueleStandProjectRandafwerking"
            id="individueleStandProjectRandafwerking"
            class="form-select bg-light"
            v-model="offerte.locatie.randAfwerking"
            @blur="valid"
          >
            <option value="" selected disabled>Randafwerking?</option>
            <option class="yes" value="Ja">Ja</option>
            <option class="no" value="Nee">Nee</option>
          </select>
        </div>
        <div v-if="offerte.locatie.randAfwerking === 'Ja'">
          <label
            id="type-finish"
            for="individueleStandProjectRandafwerkingSoort"
            >Soort randafwerking</label
          >
          <select
            name="individueleStandProjectRandafwerkingSoort"
            id="individueleStandProjectRandafwerkingSoort"
            class="form-select bg-light"
            v-model="offerte.locatie.typeAfwerking"
          >
            <option id="opt-finish" value="" selected disabled>
              Alle opties afwerkingen
            </option>
            <option id="alu-lg" value="Strip alu groot">Strip alu groot</option>
            <option id="alu-sm" value="Strip alu klein">Strip alu klein</option>
            <option id="strip" value="Kunststof strip">Kunststof strip</option>
            <option id="etc" value="Etc.">Etc.</option>
          </select>
        </div>
      </div>
      <div class="form-group col-12">
        <label for="individueleStandProjectAfdekfolie" class="form-label cover"
          >Afdekfolie?</label
        >
        <div class="border-select" id="individueleStandProjectAfdekfolie_div">
          <select
            required
            name="individueleStandProjectAfdekfolie"
            id="individueleStandProjectAfdekfolie"
            class="form-control bg-light"
            v-model="offerte.locatie.afdekFolie"
            @blur="valid"
          >
            <option class="cover" value="" selected disabled>Afdekfolie?</option>
            <option class="yes" value="Ja">Ja</option>
            <option class="no" value="Nee">Nee</option>
          </select>
        </div>
      </div>
    </div>

    <div class="row g-3 mt-1">
      <div class="form-group col">
        <label id="sal" for="aanhef_form" class="form-label"> Aanhef*</label>
        <div class="border-select" id="aanhef_form_div">
          <select
            name="aanhef_form"
            class="form-select bg-light"
            id="aanhef_form"
            aria-describedby="aanhef"
            v-model="offerte.contactGegevens.aanhef"
            required  
            @blur="valid"
          >
            <!-- <option id="sal" disabled selected value=""></option> -->
            <option id="sir" value="meneer">Dhr.</option>
            <option id="madam" value="mevrouw">Mevr.</option>
          </select>
        </div>
      </div>
    </div>

    <div class="row justify-content-between g-3 mt-2">
      <div class="form-group col-12 col-md-4">
        <label id="ft-name" for="voornaam_form" class="form-label"
          >Voornaam</label
        >
        <input
          type="text"
          class="form-control bg-light"
          name="voornaam_form"
          id="voornaam_form"
          aria-describedby="voornaam"
          v-model="offerte.contactGegevens.voornaam"
        />
      </div>
      <div class="form-group col-12 col-md-3">
        <label id="pre" for="tussenvoegsel_form" class="form-label"
          >Tussenvoegsel</label
        >
        <input
          type="text"
          class="form-control bg-light"
          name="tussenvoegsel_form"
          id="tussenvoegsel_form"
          aria-describedby="tussenvoegsel"
          v-model="offerte.contactGegevens.tussenvoegsel"
        />
      </div>
      <div class="form-group col-12 col-md-4">
        <label id="la-name" for="achternaam_form" class="form-label"
          >Achternaam*</label
        >
        <input
          type="text"
          class="form-control bg-light"
          name="achternaam_form"
          id="achternaam_form"
          aria-describedby="achternaam"
          v-model="offerte.contactGegevens.achternaam"
          required
          @blur="valid"
        />
      </div>
    </div>
    <!-- bedrijfsnaam -->
    <div class="row g-3 mt-2">
      <div class="form-group w-100">
        <div class="col">
          <label id="com-name" for="bedrijfsnaam" class="form-label"
            >Bedrijfsnaam*</label
          >
        </div>
        <div class="col">
          <input
            class="form-control bg-light"
            type="text"
            name="bedrijfsnaam"
            id="bedrijfsnaam"
            v-model="offerte.bedrijfsInformatie.bedrijfsNaam"
            required
            @blur="valid"
          />
        </div>
      </div>
    </div>
    <!-- bedrijfsactiviteit -->
    <div class="row g-3 mt-2">
      <div class="form-group col">
        <label id="activity" for="bedrijfsactiviteit" class="form-label"
          >Bedrijfsactiviteit*</label
        >
        <div class="border-select" id="bedrijfsactiviteit_div">
          <select
            class="form-select bg-light"
            name="bedrijfsactiviteit"
            id="bedrijfsactiviteit"
            v-model="offerte.bedrijfsInformatie.bedrijfsActiviteit"
            required
            @blur="valid"
          >
            <option id="select-act" disabled selected value="">
              --kies een bedrijfsactiviteit--
            </option>
            <optgroup label="EVENTMARKT KEUZES">
              <option id="con-org" value="congressen">
                Congressen & seminars organisatie
              </option>
              <option id="event-org" value="eventorganisatie">
                Eventorganisatie
              </option>
              <option id="trade-org" value="(vak)beursorganisatie">
                (Vak)Beursorganisatie
              </option>
              <option id="st-build" value="standbouwer">Standbouwer</option>
              <option id="des-fair" value="designbureau (beurs)">
                Designbureau (beurs)
              </option>
              <option id="des-construct" value="designbureau (standbouw)">
                Designbureau (standbouw)
              </option>
              <option id="des-event" value="designbureau (event)">
                Designbureau (event)
              </option>
              <option id="con-sem" value="congres & seminar locatie">
                Congres & seminar locatie
              </option>
              <option id="event-loc" value="event locatie">Event locatie</option>
              <option id="exh-loc" value="beurs locatie">Beurs locatie</option>
              <option id="mark-com" value="marketing & communicatie bureau">
                Marketing & communicatie bureau
              </option>
              <option id="proj-agen" value="projectmanagement bureau">
                Projectmanagement bureau
              </option>
              <option id="rent" value="verhuurbedrijf">Verhuurbedrijf</option>
            </optgroup>
            <optgroup label="PROJECTMARKT KEUZES">
              <option id="govern" value="(semi) overheidsinstelling">
                (Semi) Overheidsinstelling
              </option>
              <option id="con-com" value="bouwonderneming">
                Bouwonderneming
              </option>
              <option id="arch" value="architect">Architect</option>
              <option id="in-con" value="interieurbouw">Interieurbouw</option>
              <option id="des-inter" value="designbureau (interieur)">
                Designbureau (interieur)
              </option>
              <option id="retail" value="retail">Retail</option>
              <option id="cat-in" value="horeca">Horeca</option>
            </optgroup>
            <optgroup label="ALGEMEEN">
              <option id="other" value="overig">Overig</option>
            </optgroup>
          </select>
        </div>
      </div>
    </div>
    <!-- Vestigings straat -->
    <div class="row g-3 mt-2 justify-content-between">
      <div class="form-group col-12 col-md-5">
        <label id="loc-str" for="straat" class="form-label"
          >Vestigings straat*</label
        >

        <input
          class="form-control bg-light"
          type="text"
          name="straat"
          id="straat"
          v-model="offerte.vestigingAdres.vesStraat"
          aria-describedby="straat"
          required
          @blur="valid"
        />
      </div>
      <div class="form-group col-12 col-md-2">
        <label id="loc-nr" for="huisnummer" class="form-label"
          >Vestigings huisnummer*</label
        >

        <input
          class="form-control bg-light"
          type="text"
          name="huisnummer"
          id="huisnummer"
          v-model="offerte.vestigingAdres.vesHuisnummer"
          aria-describedby="huisnummer"
          required
          @blur="valid"
        />
      </div>
      <div class="form-group col-12 col-md-3">
        <label id="loc-add" for="toevoeging" class="form-label"
          >Vestigings toevoeging</label
        >

        <input
          class="form-control bg-light"
          type="text"
          name="toevoeging"
          id="toevoeging"
          v-model="offerte.vestigingAdres.vesToevoeging"
          aria-describedby="toevoeging"
        />
      </div>
    </div>
    <!-- Vestigings postcode / Vestigings plaats -->
    <div class="row g-3 mt-2 justify-content-between">
      <div class="form-group col-12 col-md-5">
        <label id="loc-zip" for="postcode" class="form-label"
          >Vestigings postcode*</label
        >
        <input
          class="form-control bg-light"
          type="text"
          name="postcode"
          id="postcode"
          v-model="offerte.vestigingAdres.vesPostcode"
          required
          @blur="valid"
        />
      </div>
      <div class="form-group col-12 col-md-6">
        <label id="loc-city" for="plaats" class="form-label"
          >Vestigings plaats*</label
        >
        <input
          class="form-control bg-light"
          type="text"
          name="plaats"
          id="plaats"
          v-model="offerte.vestigingAdres.vesPlaats"
          required
          @blur="valid"
        />
      </div>
    </div>
    <div class="row mt-2 ms-1">
      <div class="form-check col-3 col-md-3">
        <input
          class="form-check-input mb-1"
          type="checkbox"
          name="isAfleverAdres"
          v-model="isAfleverAdres"
          :checked="isAfleverAdres"
        />
        <label id="del-add" for="isAfleverAdres" class="form-check-label"
          >Afleveradres</label
        >
      </div>

      <div class="form-check col">
        <input
          type="checkbox"
          class="form-check-input mb-1"
          v-model="isFactuurAdres"
          :checked="isFactuurAdres"
          name="isFactuurAdres"
        />
        <label id="pos-add" for="isFactuurAdres" class="form-check-label"
          >Postadres / Factureringsadres</label
        >
      </div>
    </div>

    <!-- Afleveradres straat -->
    <div v-if="isAfleverAdres">
      <div class="row g-3 mt-2 justify-content-between">
        <div class="form-group col-12 col-md-5">
          <label id="del-str" for="aflStraat" class="form-label"
            >Afleveradres straat</label
          >
          <input
            class="form-control bg-light"
            type="text"
            name="aflStraat"
            id="aflStraat"
            v-model="offerte.afleverAdres.afStraat"
          />
        </div>
        <div class="form-group col-12 col-md-2">
          <label id="del-addnr" for="aflNummer" class="form-label"
            >Afleveradres huisnummer</label
          >
          <input
            class="form-control bg-light"
            type="text"
            name="aflNummer"
            id="aflNummer"
            v-model="offerte.afleverAdres.afHuisnummer"
          />
        </div>
        <div class="form-group col-12 col-md-3">
          <label id="del-suf" for="aflToevoeging" class="form-label"
            >Afleveradres Toevoeging</label
          >
          <input
            class="form-control bg-light"
            type="text"
            name="aflToevoeging"
            id="aflToevoeging"
            v-model="offerte.afleverAdres.afToevoeging"
          />
        </div>
      </div>
      <!-- Aflever postcode Aflever plaats-->
      <div class="row g-3 mt-2 justify-content-between">
        <div class="form-group col-12 col-md-5">
          <label id="del-zip" for="aflPostcode" class="form-label"
            >Aflever postcode</label
          >
          <input
            class="form-control bg-light"
            type="text"
            name="aflPostcode"
            id="aflPostcode"
            v-model="offerte.afleverAdres.afPostcode"
          />
        </div>
        <div class="form-group col-12 col-md-6">
          <label id="del-city" for="aflPlaats" class="form-label"
            >Aflever plaats</label
          >
          <input
            class="form-control bg-light"
            type="text"
            name="aflPlaats"
            id="aflPlaats"
            v-model="offerte.afleverAdres.afPlaats"
          />
        </div>
      </div>
    </div>
    <!-- Postadres straat-->

    <div v-if="isFactuurAdres">
      <div class="row g-3 mt-2 justify-content-between">
        <div class="form-group col-12 col-md-5">
          <label id="pos-str" for="PostStraat" class="form-label"
            >Postadres straat</label
          >
          <input
            class="form-control bg-light"
            type="text"
            name="PostStraat"
            id="PostStraat"
            v-model="offerte.postAdres.postStraat"
          />
        </div>
        <div class="form-group col-12 col-md-2">
          <label id="pos-nr" for="PostNummer" class="form-label"
            >Postadres nummer</label
          >
          <input
            class="form-control bg-light"
            type="nummer"
            name="PostNummer"
            id="PostNummer"
            v-model="offerte.postAdres.postHuisnummer"
          />
        </div>
        <div class="form-group col-12 col-md-3">
          <label id="pos-suf" for="PostToevoeging" class="form-label"
            >Postadres toevoeging</label
          >
          <input
            class="form-control bg-light"
            type="text"
            name="PostToevoeging"
            id="PostToevoeging"
            v-model="offerte.postAdres.postToevoeging"
          />
        </div>
      </div>

      <!-- Postadres postcode Postadres plaats -->
      <div class="row g-3 mt-2 justify-content-between">
        <div class="form-group col-12 col-md-5">
          <label id="pos-zip" for="postadresPostcode" class="form-label"
            >Postadres postcode</label
          >
          <input
            class="form-control bg-light"
            type="text"
            name="postadresPostcode"
            id="postadresPostcode"
            v-model="offerte.postAdres.postPostcode"
          />
        </div>

        <div class="form-group col-12 col-md-6">
          <label id="pos-city" for="postadresPlaats" class="form-label"
            >Postadres plaats</label
          >
          <input
            class="form-control bg-light"
            type="text"
            name="postadresPlaats"
            id="postadresPlaats"
            v-model="offerte.postAdres.postPlaats"
          />
        </div>
      </div>
    </div>

    <!-- telefoonnummer -->
    <div class="row g-3 mt-2 justify-content-between">
      <div class="form-group col-12 col-md-3">
        <label id="coun-code" for="telNummerLand" class="form-label"
          >Landcode</label
        >
        <select
          class="form-select bg-light"
          name="telNummerLand"
          id="telNummerLand"
          v-model="offerte.overige.landCode"
        >
          <option id="select-code" disabled selected value="">
            --Kies een landcode--
          </option>
          <option id="afgh" data-countryCode="AF" value="93">
            Afghanistan (+93)
          </option>
          <option id="alb" data-countryCode="AL" value="355">
            Albania (+355)
          </option>
          <option id="alge" data-countryCode="DZ" value="213">
            Algeria (+213)
          </option>
          <option id="and" data-countryCode="AD" value="376">
            Andorra (+376)
          </option>
          <option id="ango" data-countryCode="AO" value="244">
            Angola (+244)
          </option>
          <option id="angu" data-countryCode="AI" value="1264">
            Anguilla (+1264)
          </option>
          <option id="anti" data-countryCode="AG" value="1268">
            Antigua &amp; Barbuda (+1268)
          </option>
          <option id="" data-countryCode="AR" value="54">
            Argentina (+54)
          </option>
          <option id="" data-countryCode="AM" value="374">
            Armenia (+374)
          </option>
          <option id="arub" data-countryCode="AW" value="297">
            Aruba (+297)
          </option>
          <option id="asce" data-countryCode="AC" value="247">
            Ascension Island (+247)
          </option>
          <option id="austra" data-countryCode="AU" value="61">
            Australia (+61)
          </option>
          <option id="austria" data-countryCode="AT" value="43">
            Austria (+43)
          </option>
          <option id="azer" data-countryCode="AZ" value="994">
            Azerbaijan (+994)
          </option>
          <option id="baha" data-countryCode="BS" value="1242">
            Bahamas (+1242)
          </option>
          <option id="bahr" data-countryCode="BH" value="973">
            Bahrain (+973)
          </option>
          <option id="bang" data-countryCode="BD" value="880">
            Bangladesh (+880)
          </option>
          <option id="barbados" data-countryCode="BB" value="1246">
            Barbados (+1246)
          </option>
          <option id="belarus" data-countryCode="BY" value="375">
            Belarus (+375)
          </option>
          <option id="belg" data-countryCode="BE" value="32">
            Belgium (+32)
          </option>
          <option id="beli" data-countryCode="BZ" value="501">
            Belize (+501)
          </option>
          <option id="beni" data-countryCode="BJ" value="229">
            Benin (+229)
          </option>
          <option id="berm" data-countryCode="BM" value="1441">
            Bermuda (+1441)
          </option>
          <option id="bhu" data-countryCode="BT" value="975">
            Bhutan (+975)
          </option>
          <option id="bolivia" data-countryCode="BO" value="591">
            Bolivia (+591)
          </option>
          <option id="bonai" data-countryCode="BQ" value="599">
            Bonaire, Saba and Sint Eustatius (+599)
          </option>
          <option id="bosni" data-countryCode="BA" value="387">
            Bosnia Herzegovina (+387)
          </option>
          <option id="bots" data-countryCode="BW" value="267">
            Botswana (+267)
          </option>
          <option id="bra" data-countryCode="BR" value="55">
            Brazil (+55)
          </option>
          <option id="bri-ind" data-countryCode="IO" value="246">
            British Indian Ocean Territory (+246)
          </option>
          <option id="bru" data-countryCode="BN" value="673">
            Brunei (+673)
          </option>
          <option id="bulg" data-countryCode="BG" value="359">
            Bulgaria (+359)
          </option>
          <option id="burk" data-countryCode="BF" value="226">
            Burkina Faso (+226)
          </option>
          <option id="burun" data-countryCode="BI" value="257">
            Burundi (+257)
          </option>
          <option id="camb" data-countryCode="KH" value="855">
            Cambodia (+855)
          </option>
          <option id="camero" data-countryCode="CM" value="237">
            Cameroon (+237)
          </option>
          <option id="can" data-countryCode="CA" value="1">Canada (+1)</option>
          <option id="cape" data-countryCode="CV" value="238">
            Cape Verde Islands (+238)
          </option>
          <option id="cayma" data-countryCode="KY" value="1345">
            Cayman Islands (+1345)
          </option>
          <option id="cen-afr" data-countryCode="CF" value="236">
            Central African Republic (+236)
          </option>
          <option id="chad" data-countryCode="TD" value="235">
            Chad (+235)
          </option>
          <option id="chile" data-countryCode="CL" value="56">
            Chile (+56)
          </option>
          <option id="china" data-countryCode="CN" value="86">
            China (+86)
          </option>
          <option id="colom" data-countryCode="CO" value="57">
            Colombia (+57)
          </option>
          <option id="comor" data-countryCode="KM" value="269">
            Comoros (+269)
          </option>
          <option id="congo" data-countryCode="CG" value="242">
            Congo (+242)
          </option>
          <option id="congo-demo" data-countryCode="CD" value="243">
            Congo, Democratic Republic of the (+243)
          </option>
          <option id="cook-is" data-countryCode="CK" value="682">
            Cook Islands (+682)
          </option>
          <option id="costa" data-countryCode="CR" value="506">
            Costa Rica (+506)
          </option>
          <option id="croa" data-countryCode="HR" value="385">
            Croatia (+385)
          </option>
          <option id="cuba" data-countryCode="CU" value="53">Cuba (+53)</option>
          <option id="cura" data-countryCode="CW" value="5999">
            Curaçao (+5999)
          </option>
          <option id="cyp" data-countryCode="CY" value="357">
            Cyprus (+357)
          </option>
          <option id="cze" data-countryCode="CZ" value="420">
            Czech Republic (+420)
          </option>
          <option id="denm" data-countryCode="DK" value="45">
            Denmark (+45)
          </option>
          <option id="djib" data-countryCode="DJ" value="253">
            Djibouti (+253)
          </option>
          <option id="domini" data-countryCode="DM" value="1767">
            Dominica (+1767)
          </option>
          <option id="dom-rep" data-countryCode="DO" value="1809">
            Dominican Republic (+1809)
          </option>
          <option id="eastti" data-countryCode="TL" value="670">
            East Timor (+670)
          </option>
          <option id="ecua" data-countryCode="EC" value="593">
            Ecuador (+593)
          </option>
          <option id="egy" data-countryCode="EG" value="20">Egypt (+20)</option>
          <option id="elsa" data-countryCode="SV" value="503">
            El Salvador (+503)
          </option>
          <option id="equa" data-countryCode="GQ" value="240">
            Equatorial Guinea (+240)
          </option>
          <option id="erit" data-countryCode="ER" value="291">
            Eritrea (+291)
          </option>
          <option id="esto" data-countryCode="EE" value="372">
            Estonia (+372)
          </option>
          <option id="eswa" data-countryCode="SZ" value="268">
            Eswatini (+268)
          </option>
          <option id="ethi" data-countryCode="ET" value="251">
            Ethiopia (+251)
          </option>
          <option id="falkla" data-countryCode="FK" value="500">
            Falkland Islands (+500)
          </option>
          <option id="faroe" data-countryCode="FO" value="298">
            Faroe Islands (+298)
          </option>
          <option id="fiji" data-countryCode="FJ" value="679">
            Fiji (+679)
          </option>
          <option id="finl" data-countryCode="FI" value="358">
            Finland (+358)
          </option>
          <option id="fra" data-countryCode="FR" value="33">
            France (+33)
          </option>
          <option id="french-g" data-countryCode="GF" value="594">
            French Guiana (+594)
          </option>
          <option id="french-p" data-countryCode="PF" value="689">
            French Polynesia (+689)
          </option>
          <option id="gabo" data-countryCode="GA" value="241">
            Gabon (+241)
          </option>
          <option id="gambi" data-countryCode="GM" value="220">
            Gambia (+220)
          </option>
          <option id="georg" data-countryCode="GE" value="995">
            Georgia (+995)
          </option>
          <option id="germ" data-countryCode="DE" value="49">
            Germany (+49)
          </option>
          <option id="ghana" data-countryCode="GH" value="233">
            Ghana (+233)
          </option>
          <option id="gibra" data-countryCode="GI" value="350">
            Gibraltar (+350)
          </option>
          <option id="greece" data-countryCode="GR" value="30">
            Greece (+30)
          </option>
          <option id="green" data-countryCode="GL" value="299">
            Greenland (+299)
          </option>
          <option id="gren" data-countryCode="GD" value="1473">
            Grenada (+1473)
          </option>
          <option id="guad" data-countryCode="GP" value="590">
            Guadeloupe (+590)
          </option>
          <option id="guam" data-countryCode="GU" value="1671">
            Guam (+1671)
          </option>
          <option id="guat" data-countryCode="GT" value="502">
            Guatemala (+502)
          </option>
          <option id="guin" data-countryCode="GN" value="224">
            Guinea (+224)
          </option>
          <option id="guinea-b" data-countryCode="GW" value="245">
            Guinea - Bissau (+245)
          </option>
          <option id="guy" data-countryCode="GY" value="592">
            Guyana (+592)
          </option>
          <option id="hai" data-countryCode="HT" value="509">
            Haiti (+509)
          </option>
          <option id="hond" data-countryCode="HN" value="504">
            Honduras (+504)
          </option>
          <option id="hk" data-countryCode="HK" value="852">
            Hong Kong (+852)
          </option>
          <option id="hung" data-countryCode="HU" value="36">
            Hungary (+36)
          </option>
          <option id="icel" data-countryCode="IS" value="354">
            Iceland (+354)
          </option>
          <option id="india" data-countryCode="IN" value="91">
            India (+91)
          </option>
          <option id="indo" data-countryCode="ID" value="62">
            Indonesia (+62)
          </option>
          <option id="iran" data-countryCode="IR" value="98">Iran (+98)</option>
          <option id="iraq" data-countryCode="IQ" value="964">
            Iraq (+964)
          </option>
          <option id="irel" data-countryCode="IE" value="353">
            Ireland (+353)
          </option>
          <option id="isra" data-countryCode="IL" value="972">
            Israel (+972)
          </option>
          <option id="ita" data-countryCode="IT" value="39">Italy (+39)</option>
          <option id="ivory" data-countryCode="CI" value="225">
            Ivory Coast (+225)
          </option>
          <option id="jamai" data-countryCode="JM" value="1876">
            Jamaica (+1876)
          </option>
          <option id="jap" data-countryCode="JP" value="81">Japan (+81)</option>
          <option id="jord" data-countryCode="JO" value="962">
            Jordan (+962)
          </option>
          <option id="kaza" data-countryCode="KZ" value="7">
            Kazakhstan (+7)
          </option>
          <option id="kenya" data-countryCode="KE" value="254">
            Kenya (+254)
          </option>
          <option id="kiri" data-countryCode="KI" value="686">
            Kiribati (+686)
          </option>
          <option id="kor-n" data-countryCode="KP" value="850">
            Korea, North (+850)
          </option>
          <option id="kor-s" data-countryCode="KR" value="82">
            Korea, South (+82)
          </option>
          <option id="kos" data-countryCode="XK" value="383">
            Kosovo (+383)
          </option>
          <option id="kuw" data-countryCode="KW" value="965">
            Kuwait (+965)
          </option>
          <option id="kyrg" data-countryCode="KG" value="996">
            Kyrgyzstan (+996)
          </option>
          <option id="laos" data-countryCode="LA" value="856">
            Laos (+856)
          </option>
          <option id="latv" data-countryCode="LV" value="371">
            Latvia (+371)
          </option>
          <option id="laba" data-countryCode="LB" value="961">
            Lebanon (+961)
          </option>
          <option id="leso" data-countryCode="LS" value="266">
            Lesotho (+266)
          </option>
          <option id="libe" data-countryCode="LR" value="231">
            Liberia (+231)
          </option>
          <option id="liby" data-countryCode="LY" value="218">
            Libya (+218)
          </option>
          <option id="liech" data-countryCode="LI" value="423">
            Liechtenstein (+423)
          </option>
          <option id="lith" data-countryCode="LT" value="370">
            Lithuania (+370)
          </option>
          <option id="luxe" data-countryCode="LU" value="352">
            Luxembourg (+352)
          </option>
          <option id="mac" data-countryCode="MO" value="853">
            Macao (+853)
          </option>
          <option id="maced" data-countryCode="MK" value="389">
            Macedonia (+389)
          </option>
          <option id="madag" data-countryCode="MG" value="261">
            Madagascar (+261)
          </option>
          <option id="malaw" data-countryCode="MW" value="265">
            Malawi (+265)
          </option>
          <option id="malay" data-countryCode="MY" value="60">
            Malaysia (+60)
          </option>
          <option id="maldi" data-countryCode="MV" value="960">
            Maldives (+960)
          </option>
          <option id="mali" data-countryCode="ML" value="223">
            Mali (+223)
          </option>
          <option id="malta" data-countryCode="MT" value="356">
            Malta (+356)
          </option>
          <option id="marsha" data-countryCode="MH" value="692">
            Marshall Islands (+692)
          </option>
          <option id="martin" data-countryCode="MQ" value="596">
            Martinique (+596)
          </option>
          <option id="maurita" data-countryCode="MR" value="222">
            Mauritania (+222)
          </option>
          <option id="mau-riti" data-countryCode="MU" value="230">
            Mauritius (+230)
          </option>
          <option id="mayo" data-countryCode="YT" value="262">
            Mayotte (+262)
          </option>
          <option id="mex" data-countryCode="MX" value="52">
            Mexico (+52)
          </option>
          <option id="micro" data-countryCode="FM" value="691">
            Micronesia (+691)
          </option>
          <option id="mold" data-countryCode="MD" value="373">
            Moldova (+373)
          </option>
          <option id="mona" data-countryCode="MC" value="377">
            Monaco (+377)
          </option>
          <option id="mongo" data-countryCode="MN" value="976">
            Mongolia (+976)
          </option>
          <option id="monten" data-countryCode="ME" value="382">
            Montenegro (+382)
          </option>
          <option id="montser" data-countryCode="MS" value="1664">
            Montserrat (+1664)
          </option>
          <option id="moroc" data-countryCode="MA" value="212">
            Morocco (+212)
          </option>
          <option id="mozam" data-countryCode="MZ" value="258">
            Mozambique (+258)
          </option>
          <option id="myam" data-countryCode="MN" value="95">
            Myanmar (+95)
          </option>
          <option id="nami" data-countryCode="NA" value="264">
            Namibia (+264)
          </option>
          <option id="nau" data-countryCode="NR" value="674">
            Nauru (+674)
          </option>
          <option id="nep" data-countryCode="NP" value="977">
            Nepal (+977)
          </option>
          <option id="nl" data-countryCode="NL" value="31">
            Netherlands (+31)
          </option>
          <option id="new-c" data-countryCode="NC" value="687">
            New Caledonia (+687)
          </option>
          <option id="new-z" data-countryCode="NZ" value="64">
            New Zealand (+64)
          </option>
          <option id="nicara" data-countryCode="NI" value="505">
            Nicaragua (+505)
          </option>
          <option id="niger" data-countryCode="NE" value="227">
            Niger (+227)
          </option>
          <option id="nigeria" data-countryCode="NG" value="234">
            Nigeria (+234)
          </option>
          <option id="niue" data-countryCode="NU" value="683">
            Niue (+683)
          </option>
          <option id="norf" data-countryCode="NF" value="672">
            Norfolk Islands (+672)
          </option>
          <option id="nort-mar" data-countryCode="NP" value="1670">
            Northern Mariana Islands (+1670)
          </option>
          <option id="nor" data-countryCode="NO" value="47">
            Norway (+47)
          </option>
          <option id="oman" data-countryCode="OM" value="968">
            Oman (+968)
          </option>
          <option id="pak" data-countryCode="PK" value="92">
            Pakistan (+92)
          </option>
          <option id="pal" data-countryCode="PW" value="680">
            Palau (+680)
          </option>
          <option id="pales" data-countryCode="PS" value="970">
            Palestine (+970)
          </option>
          <option id="pan" data-countryCode="PA" value="507">
            Panama (+507)
          </option>
          <option id="papua" data-countryCode="PG" value="675">
            Papua New Guinea (+675)
          </option>
          <option id="para" data-countryCode="PY" value="595">
            Paraguay (+595)
          </option>
          <option id="peru" data-countryCode="PE" value="51">Peru (+51)</option>
          <option id="philip" data-countryCode="PH" value="63">
            Philippines (+63)
          </option>
          <option id="pol" data-countryCode="PL" value="48">
            Poland (+48)
          </option>
          <option id="portu" data-countryCode="PT" value="351">
            Portugal (+351)
          </option>
          <option id="puerto" data-countryCode="PR" value="1787">
            Puerto Rico (+1787)
          </option>
          <option id="qatar" data-countryCode="QA" value="974">
            Qatar (+974)
          </option>
          <option id="reun" data-countryCode="RE" value="262">
            Réunion (+262)
          </option>
          <option id="rom" data-countryCode="RO" value="40">
            Romania (+40)
          </option>
          <option id="russ" data-countryCode="RU" value="7">Russia (+7)</option>
          <option id="rwa" data-countryCode="RW" value="250">
            Rwanda (+250)
          </option>
          <option id="samo" data-countryCode="WS" value="685">
            Samoa (+685)
          </option>
          <option id="san-ma" data-countryCode="SM" value="378">
            San Marino (+378)
          </option>
          <option id="sao-tome" data-countryCode="ST" value="239">
            São Tomé &amp; Principe (+239)
          </option>
          <option id="saudi" data-countryCode="SA" value="966">
            Saudi Arabia (+966)
          </option>
          <option id="seneg" data-countryCode="SN" value="221">
            Senegal (+221)
          </option>
          <option id="serb" data-countryCode="CS" value="381">
            Serbia (+381)
          </option>
          <option id="seych" data-countryCode="SC" value="248">
            Seychelles (+248)
          </option>
          <option id="siera" data-countryCode="SL" value="232">
            Sierra Leone (+232)
          </option>
          <option id="sing" data-countryCode="SG" value="65">
            Singapore (+65)
          </option>
          <option id="slova" data-countryCode="SK" value="421">
            Slovakia (+421)
          </option>
          <option id="slove" data-countryCode="SI" value="386">
            Slovenia (+386)
          </option>
          <option id="solo" data-countryCode="SB" value="677">
            Solomon Islands (+677)
          </option>
          <option id="somalia" data-countryCode="SO" value="252">
            Somalia (+252)
          </option>
          <option id="sou-afr" data-countryCode="ZA" value="27">
            South Africa (+27)
          </option>
          <option id="sou-su" data-countryCode="SS" value="211">
            South Sudan (+211)
          </option>
          <option id="spain" data-countryCode="ES" value="34">
            Spain (+34)
          </option>
          <option id="sri-la" data-countryCode="LK" value="94">
            Sri Lanka (+94)
          </option>
          <option id="st-hel" data-countryCode="SH" value="290">
            St. Helena (+290)
          </option>
          <option id="st-kit" data-countryCode="KN" value="1869">
            St. Kitts and Nevis (+1869)
          </option>
          <option id="st-kit" data-countryCode="SC" value="1758">
            St. Lucia (+1758)
          </option>
          <option id="st-luc" data-countryCode="PM" value="508">
            St. Pierre and Miquelon (+508)
          </option>
          <option id="st-pie" data-countryCode="SD" value="249">
            Sudan (+249)
          </option>
          <option id="sudan" data-countryCode="SR" value="597">
            Suriname (+597)
          </option>
          <option id="suri" data-countryCode="SE" value="46">
            Sweden (+46)
          </option>
          <option id="swe" data-countryCode="CH" value="41">
            Switzerland (+41)
          </option>
          <option id="swit" data-countryCode="SI" value="963">
            Syria (+963)
          </option>
          <option id="syri" data-countryCode="TW" value="886">
            Taiwan (+886)
          </option>
          <option id="taji" data-countryCode="TJ" value="992">
            Tajikstan (+992)
          </option>
          <option id="tanz" data-countryCode="TZ" value="255">
            Tanzania (+255)
          </option>
          <option id="thai" data-countryCode="TH" value="66">
            Thailand (+66)
          </option>
          <option id="togo" data-countryCode="TG" value="228">
            Togo (+228)
          </option>
          <option id="toke" data-countryCode="TK" value="690">
            Tokelau (+690)
          </option>
          <option id="tonga" data-countryCode="TO" value="676">
            Tonga (+676)
          </option>
          <option id="trini" data-countryCode="TT" value="1868">
            Trinidad &amp; Tobago (+1868)
          </option>
          <option id="tunis" data-countryCode="TN" value="216">
            Tunisia (+216)
          </option>
          <option id="turk" data-countryCode="TR" value="90">
            Turkey (+90)
          </option>
          <option id="turkme" data-countryCode="TM" value="993">
            Turkmenistan (+993)
          </option>
          <option id="tur-cai" data-countryCode="TC" value="1649">
            Turks &amp; Caicos Islands (+1649)
          </option>
          <option id="tuv" data-countryCode="TV" value="688">
            Tuvalu (+688)
          </option>
          <option id="uga" data-countryCode="UG" value="256">
            Uganda (+256)
          </option>
          <option id="ukra" data-countryCode="UA" value="380">
            Ukraine (+380)
          </option>
          <option id="uni-arab" data-countryCode="AE" value="971">
            United Arab Emirates (+971)
          </option>
          <option id="uk" data-countryCode="GB" value="44">
            United Kingdom (+44)
          </option>
          <option id="usa" data-countryCode="US" value="1">
            United States of America (+1)
          </option>
          <option id="uru" data-countryCode="UY" value="598">
            Uruguay (+598)
          </option>
          <option id="uzbe" data-countryCode="UZ" value="998">
            Uzbekistan (+998)
          </option>
          <option id="vanu" data-countryCode="VU" value="678">
            Vanuatu (+678)
          </option>
          <option id="vat-city" data-countryCode="VA" value="39">
            Vatican City (+39)
          </option>
          <option id="venez" data-countryCode="VE" value="58">
            Venezuela (+58)
          </option>
          <option id="viet" data-countryCode="VN" value="84">
            Vietnam (+84)
          </option>
          <option id="virg-bri" data-countryCode="VG" value="1284">
            Virgin Islands - British (+1284)
          </option>
          <option id="virg-us" data-countryCode="VI" value="1340">
            Virgin Islands - US (+1340)
          </option>
          <option id="wallis" data-countryCode="WF" value="681">
            Wallis &amp; Futuna (+681)
          </option>
          <option id="sah" data-countryCode="EH" value="967">
            Western Sahara (+212)
          </option>
          <option id="yem" data-countryCode="YE" value="967">
            Yemen (+967)
          </option>
          <option id="zambia" data-countryCode="ZM" value="260">
            Zambia (+260)
          </option>
          <option id="zimbab" data-countryCode="ZW" value="263">
            Zimbabwe (+263)
          </option>
        </select>
      </div>

      <div class="form-group col-12 col-md-8">
        <label id="tel-nr" for="telefoonnummer" class="form-label"
          >Telefoonnummer*</label
        >
        <input
          class="form-control bg-light"
          type="tel"
          minlength=7
          maxlength=15
          pattern="[0-9]{7,15}"
          name="telefoonnummer"
          id="telefoonnummer"
          v-model="offerte.overige.eigenTelefoonNummer"
          required
          @blur="valid"
        />
      </div>
    </div>

    <!-- email -->
    <div class="row g-3 mt-2">
      <div class="form-group col">
        <label id="email" for="email" class="form-label">Email*</label>
        <input
          class="form-control bg-light"
          type="email"
          name="email"
          id="email"
          v-model="offerte.overige.eigenEmail"
          required
          @blur="valid"
        />
      </div>
    </div>
    <div class="row g-3 mt-2">
      <div class="form-group col">
        <label id="comm" for="Eigenopmerking" class="form-label"
          >Eigen opmerking</label
        >
        <textarea
          class="form-control bg-light"
          name="Eigenopmerking"
          id="Eigenopmerking"
          v-model="offerte.overige.eigenOpmerking"
        />
      </div>
    </div>
    <div
      class="row g-3 mt-2"
      id="deliveryLine"
      v-if="offerte.leveringsManier === 'levering'"
    >
      *Datum leveringen onder voorbehoud voorraad, productie, planning en
      transport
    </div>
    <div class="row g-3 mt-2 justify-content-between">
      <button
        id="back"
        class="btn btn-grey my-4 col-3 text-decoration-none fontSizeButton"
        @mouseup="storeForm()"
      >
        <i class="fas fa-arrow-left"></i>
        Terug
      </button>
      <button
        class="btn btn-grey apartebtnStyle2 my-4 col-3 fontSizeButton"
        id="quot"

        type="btn"
      >
        Offerte aanvraag versturen
      </button>
    </div>
  </form>
</template>
<script>

export default {
  data() {
    return {
      offerte: {
        bestellingType: this.event,
        projectNaam: "",
        projectLand: "",
        projectLocatie: "",
        leveringsManier: "levering",
        datum: {
          levering: "",
          montage: "",
          demontage: "",
        },
        locatie: {
          halNaam: "",
          halNummer: "",
          standNummer: "",
          standSoort: "",
          stroomWaterPunt: "",
          standLengte: "",
          standBreedte: "",
          // standVierkanteMeter:"",
          verhoogdeVloer: "",
          opleveringTijd: "",
          opleveringDatum: "",
          randAfwerking: "",
          typeAfwerking: "",
          afdekFolie: "",
        },
        bedrijfsInformatie: {
          bedrijfsNaam: "",
          bedrijfsActiviteit: "",
          bedrijfsAdres: "",
          bedrijfsPostcode: "",
          bedrijfsPlaats: "",
          telefoonNet: "",
          bedrijfsTelefoon: "",
          bedrijfsEmail: "",
        },
        vestigingAdres: {
          vesStraat: "",
          vesHuisnummer: "",
          vesToevoeging: "",
          vesPostcode: "",
          vesPlaats: "",
        },
        afleverAdres: {
          afStraat: "",
          afHuisnummer: "",
          afToevoeging: "",
          afPostcode: "",
          afPlaats: "",
        },
        postAdres: {
          postStraat: "",
          postHuisnummer: "",
          postToevoeging: "",
          postPostcode: "",
          postPlaats: "",
        },
        overige: {
          landCode: "",
          eigenTelefoonNummer: "",
          eigenEmail: "",
          eigenOpmerking: "",
        },
        contactGegevens: {
          aanhef: "",
          voornaam: "",
          tussenvoegsel: "",
          achternaam: "",
        },
      },
      isAfleverAdres: false,
      isFactuurAdres: false,
      color:{
        valid:"#ced4da",
        invalid:"red"
      },
      border:{
        valid:"1px solid",
        invalid:"1px solid"
      },
    };
  },
  props: {
    event: String,
  },
  created() {
    this.getForm();
  },
  updated() {
    this.$store.commit("storeLocUpdate", true);
  },
  methods: {
    storeForm() {
      this.$store.commit("storeAPPLICATION", this.offerte);

      const selection = this.$Functions.getSelection(this.$route.name);

      const routes = this.$router.options.routes;

      let routeName = `${selection.lang}-${this.$RouteNames.assortment}`;

      if (
        this.$route.name === `${selection.lang}-${this.$RouteNames.application}`
      ) {
        for (let index in routes) {
          if (routes[index].path === this.$router.options.history.state.back) {
            routeName = `${selection.lang}-${
              this.$Functions.getSelection(routes[index].name).code
            }`;
            break;
          }
        }
      }
      this.$router.push({ name: routeName });
    },
    getForm() {
      let offerte = this.$store.getters.getAPPLICATION;
      if (offerte !== undefined) {
        this.offerte = offerte;
      }
    },
    async sendPDF() {
      
      event.preventDefault();
 
      if(!event.target.checkValidity()){      
        
        if(this.event === "" ){
          document.getElementById("bestellingType").style.borderColor = this.color.invalid;
        }

        // set style inputs
        const inputs = document.querySelectorAll("input") 

        for(let index = 0 ; index < inputs.length; index++){
            if(!inputs[index].validity.valid){            
              inputs[index].style.borderColor = this.color.invalid;
            }
        }

        // set style select divs
        const selects = document.querySelectorAll("select") 

        for(let index = 0 ; index < selects.length; index++){
            if(!selects[index].validity.valid){       
              const select_div = document.getElementById(`${selects[index].id}_div`);
              if( select_div != null){
                select_div.style.border = `${this.border.invalid} ${this.color.invalid}`;
              }
            }
        }
        
        return;
      }


      const project = { offerte: this.offerte, product: {} };

      project.offerte.bedrijfsInformatie.bedrijfsAdres =
        project.offerte.vestigingAdres.vesStraat +
        " " +
        project.offerte.vestigingAdres.vesHuisnummer +
        " " +
        project.offerte.vestigingAdres.vesToevoeging;

      project.offerte.bestellingType = this.event;


      let cart = this.$store.getters.getCART;

      for (let i = 0; i < cart.length; i++) {
        const product = cart[i];

        project.product["prod" + i] = {
          aantal: product.amount,
          assortiment: product.assortiment,
          kleur: product.kleur,
          naam: product.naam,
          width: "n.v.t",
        };
        project.product["prod" + i].naam = product.naam;
        if (product.selectedRol !== undefined && product.selectedRol !== null) {
          project.product["prod" + i].width = product.selectedRol;
        }

        project.product["prod" + i].aantal = product.amount;
        project.product["prod" + i].kleur = product.kleur;
        project.product["prod" + i].assortiment = product.assortiment;
      }

      // get date
      const date = this.$Functions.date(3);

      let data = {
        eb: this.$OTAP,
        tb: 4,
        datum: date.full,
        project: project,
        naw: {},
      };

      // insert odd values

      // insert NAW data
      let recipient = project.offerte.contactGegevens.aanhef + " ";

      if (
        project.offerte.contactGegevens.tussenvoegsel !== "" &&
        project.offerte.contactGegevens.tussenvoegsel !== undefined
      ) {
        recipient =
          project.offerte.contactGegevens.tussenvoegsel +
          " " +
          project.offerte.contactGegevens.achternaam;
      } else {
        recipient = project.offerte.contactGegevens.achternaam;
      }

      data.naw = {
        r: recipient,
        e: project.offerte.overige.eigenEmail,
      };

      // create JSON from data
      data = JSON.stringify(data);

      // verstuur data
      const response = await this.$Functions.zap(data);

      // check response on succes
      if (response.status === "success") {
        //do stuff if success

        // Get language
        let langArray = "";
        let langMain = "";

        if (this.$store.getters.getLang.includes("-")) {
          langArray = this.$store.getters.getLang.split("-");
          langMain = langArray[0].toLowerCase();
        } else {
          langMain = this.$store.getters.getLang.toLowerCase();
        }

        this.$router.push({ name: `${langMain}-${this.$RouteNames.outro}` });
      }
    },
    // set form style
    valid(){

      const element = event.target;

      if(!element.validity.valid){  
        if(element.nodeName.toLowerCase() == "input"){
          element.style.borderColor = this.color.invalid;
        }
        else{
          const element_div = document.getElementById(`${element.id}_div`);
          if(element_div != null){
            element_div.style.border = `${this.border.invalid} ${this.color.invalid}`;
          }     
        }       
      }
      else{
        if(element.nodeName.toLowerCase() == "input"){
          element.style.borderColor = this.color.valid;
        }
        else{
          const element_div = document.getElementById(`${element.id}_div`);
          if(element_div != null){
            element_div.style.border = `${this.border.valid} ${this.color.valid}`;
          }
        }
      }
    }
  },
  computed: {  },
};
</script>
